module.exports = __webpack_public_path__ + "static/media/Pic-0521.642d3bf0.jpg";